/**
 * @author Ashish Dwivedi <ashish.dwivedi@314ecorp.com>
 * @description Plan's card component
 */
import _ from 'lodash';
import { CheckOne } from '@icon-park/react';
import { Card, Col, Flex, Row, Space, Typography } from 'antd';

import { GREEN_HEX_CODE } from 'app-constants/eligibility';
import { renderPlanName } from 'utils/admin/subscriptions';

const CLASS_NAMES = {
	planCard: 'mt-0! h-full! rounded-md! shadow-[1px_1px_12px_0px_#14142b14]!',
	activePlanCard: 'active-plan-card m-0',
	activePlanCardModal: 'active-plan-card-modal w-[560px]',
};

/**
 * ActivePlanCard Component
 */
const ActivePlanCard: React.FC<{ plan: Subscriptions.IActivePlanModel }> = ({ plan }) => {
	return (
		<Card
			title={
				<Typography.Title className='m-0' level={4}>
					{renderPlanName(plan?.plan_name)}
				</Typography.Title>
			}
			className={`${CLASS_NAMES.planCard} ${CLASS_NAMES.activePlanCard}`}
		>
			<Typography.Title level={5} className='my-0 py-2.5 whitespace-pre-line'>
				{plan?.description}
			</Typography.Title>
			<Row gutter={[20, 20]}>
				{_.map(plan?.features, (feature, key) => (
					<Col key={key}>
						<Flex align='center' gap={8}>
							<CheckOne theme='filled' fill={GREEN_HEX_CODE} className='flex' />
							<Typography.Text>{feature}</Typography.Text>
						</Flex>
					</Col>
				))}
			</Row>
		</Card>
	);
};
/**
 * AddOn features Component
 */
const AddOnFeaturesCard: React.FC<{ addOn: Subscriptions.IAddOnResponseModel }> = ({ addOn }) => {
	return (
		<Card className={`${CLASS_NAMES.planCard} ${CLASS_NAMES.activePlanCard}`}>
			<Typography.Title level={3}>{addOn?.name}</Typography.Title>
			<Row gutter={[20, 20]}>
				{_.map(addOn?.features, (feature, key) => (
					<Col key={key}>
						<Space direction='horizontal' align='start'>
							<CheckOne fill={GREEN_HEX_CODE} />
							<Typography.Text>{feature}</Typography.Text>
						</Space>
					</Col>
				))}
			</Row>
		</Card>
	);
};

export { CLASS_NAMES, ActivePlanCard, AddOnFeaturesCard };
